import React from 'react';

const coins = [
  { symbol: 'BTC', name: 'Bitcoin', color: '#F7931A', bg: '#FFF7ED', daily: '0.00000284' },
  { symbol: 'ETH', name: 'Ethereum', color: '#627EEA', bg: '#EEF2FF', daily: '0.0000412' },
  { symbol: 'LTC', name: 'Litecoin', color: '#9CA3AF', bg: '#F9FAFB', daily: '0.000184' },
  { symbol: 'DOGE', name: 'Dogecoin', color: '#C3A634', bg: '#FFFBEB', daily: '0.842' },
  { symbol: 'USDT', name: 'USDT Tron', color: '#26A17B', bg: '#ECFDF5', daily: '0.0520' },
  { symbol: 'TRX', name: 'Tron', color: '#EF0027', bg: '#FFF1F2', daily: '0.924' },
];

const stats = [
  { label: 'Active Users', value: '284,910' },
  { label: 'Total Paid Out', value: '$2.4M+' },
  { label: 'Daily Claims', value: '47,382' },
];

export default function AuthBrandPanel() {
  return (
    <div className="hidden lg:flex flex-col justify-between w-[480px] xl:w-[540px] shrink-0 bg-gradient-to-br from-sky-600 via-sky-500 to-cyan-400 px-10 xl:px-14 py-12 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-white/10" />
        <div className="absolute bottom-32 -left-16 w-48 h-48 rounded-full bg-white/5" />
        <div className="absolute top-1/2 right-8 w-24 h-24 rounded-full bg-white/10" />
      </div>
      {/* Top: logo + tagline */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center border border-white/30">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <polygon points="12,2 22,7.5 22,16.5 12,22 2,16.5 2,7.5" fill="white" opacity="0.95" />
              <path d="M12 7 L12 17 M8.5 12 L15.5 12" stroke="#0EA5E9" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </div>
          <span className="text-white font-extrabold text-2xl tracking-tight">CryptoFaucet</span>
        </div>

        <h1 className="text-white text-3xl xl:text-4xl font-extrabold leading-tight mb-3">
          Earn free crypto<br />every single day.
        </h1>
        <p className="text-sky-100 text-base leading-relaxed mb-8">
          Claim from 6 different cryptocurrencies daily. Complete tasks to boost your earnings. Withdraw anytime to your wallet.
        </p>

        {/* Coin cards */}
        <div className="grid grid-cols-2 gap-3">
          {coins?.map((coin) => (
            <div
              key={`brand-coin-${coin?.symbol}`}
              className="bg-white/15 backdrop-blur-sm border border-white/20 rounded-2xl px-4 py-3 flex items-center gap-3"
            >
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-extrabold text-white shrink-0"
                style={{ backgroundColor: coin?.color }}
              >
                {coin?.symbol?.charAt(0)}
              </div>
              <div>
                <p className="text-white text-xs font-bold leading-none">{coin?.symbol}</p>
                <p className="text-sky-200 text-xs mt-0.5 tabular-nums">+{coin?.daily}/day</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom: stats */}
      <div className="relative z-10">
        <div className="border-t border-white/20 pt-6 grid grid-cols-3 gap-4">
          {stats?.map((s) => (
            <div key={`stat-${s?.label}`} className="text-center">
              <p className="text-white font-extrabold text-xl tabular-nums">{s?.value}</p>
              <p className="text-sky-200 text-xs mt-0.5">{s?.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}